import classNames from 'classnames';
import { capitalize } from 'lodash';
import * as React from 'react';
import SvgIcon, { ISvgIconProps } from '../../components/SvgIcon';

export interface IWithIcon {
  iconPosition?: 'start' | 'end';
  className?: string;
}

const withIcon = (componentClassNamespace: string): any => {
  return <OriginalProps extends {}>(WrappedComponent: React.ComponentType<OriginalProps>) => {
    const WrappedComponentWithIcon: React.FunctionComponent<OriginalProps & ISvgIconProps & IWithIcon> = ({
      iconName,
      iconWidth,
      iconHeight,
      iconFill,
      className,
      children,
      iconPosition = 'start',
      // @ts-ignore
      ...props
    }) => {
      const content: React.ReactNode[] = [
        <span className={`${componentClassNamespace}-icon`} key={'icon'}>
          <SvgIcon iconName={iconName} iconWidth={iconWidth} iconHeight={iconHeight} iconFill={iconFill} />
        </span>,
        children && (
          <span className={`${componentClassNamespace}-content`} key={'content'}>
            {children}
          </span>
        ),
      ];

      const iconPositionModifier = `iconPosition${capitalize(iconPosition)}`;
      const cn = classNames(
        className,
        `${componentClassNamespace}--${iconPositionModifier}`,
        `${componentClassNamespace}--withIcon`,
      );

      if (iconPosition.toLowerCase() === 'end') {
        content.reverse();
      }
      return (
        <WrappedComponent {...(props as any)} className={cn}>
          {content}
        </WrappedComponent>
      );
    };

    WrappedComponentWithIcon.displayName = `withIcon(${WrappedComponent.displayName})`;

    return WrappedComponentWithIcon;
  };
};

export default withIcon;



// WEBPACK FOOTER //
// ./src/hocs/withIcon/index.tsx